import { fullDaysBetween } from "./Time"

export const isStreakExpired = (streakExpiration: number) => (date1: Date, date2: Date) => {
    return fullDaysBetween(date2, date1) > streakExpiration
}

export const calcStreakLength = (streakExpiration: number) => (dates: Date[]) => {
    dates.sort((a, b) => b.getTime() - a.getTime())
    let streak = 0
    for (let i = 0; i < dates.length - 1; i++) {
        if (!isStreakExpired(streakExpiration)(dates[i + 1], dates[i])) {
            streak++
        } else {
            return streak
        }
    }
    return streak
}